import {UPDATE_VARIANT} from '@/features/feed/queries/useGetContentById'
import styled, {css, DefaultTheme, FlattenInterpolation, ThemeProps} from 'styled-components'

const StyledMuralSection = css`
    ${() => css`
        ${({theme: {flexUtils, spacing, typography, mediaQueries, palette}}) => css`
            ${flexUtils.centered}
            color: ${palette.neutral.white};
            width: 100%;
            height: 100%;
            position: relative;
            z-index: 0;
            & > *:last-child {
                position: absolute;
                top: 0;
                left: 0;
                z-index: -1;
                cursor: default;
                & > div {
                    z-index: 0;
                }
                &::after {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    backdrop-filter: blur(12px);
                    border-radius: 46px;
                }
            }
            & ${StyledRestrictionContent} {
                ${flexUtils.centered}
                text-align: center;
                flex-direction: column;
                max-width: 310px;
                gap: ${spacing}px;
                padding: 0 ${spacing}px;
                & h1 {
                    ${typography.textXl}
                    font-weight: 600;
                    line-height: normal;
                }
                & p {
                    line-height: normal;
                }
                ${mediaQueries.m} {
                    max-width: 340px;
                    & h1 {
                        ${typography.text2Xl}
                    }
                    & p {
                        ${typography.textMd}
                    }
                }
                & button {
                    display: flex;
                    width: min-content;
                    gap: ${spacing / 2}px;
                    max-height: 24px;
                    margin-top: ${spacing}px;
                }
            }
        `}
    `}
`
const StyledChatSection = css`
    ${() => css`
        ${({theme: {flexUtils, spacing, typography, palette}}) => css`
            ${flexUtils.centered}
            max-height: 100%;
            overflow: hidden;
            position: relative;
            z-index: 0;
            width: 190px;
            height: 180px;
            color: ${palette.neutral.white};

            & > *:last-child {
                position: absolute;
                top: 0;
                left: 0;
                z-index: -1;
                cursor: default;
                & > div {
                    z-index: 0;
                }
                &::after {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    border-radius: 46px;
                    z-index: 1;
                }
            }
            & ${StyledRestrictionContent} {
                ${flexUtils.centered}
                text-align: center;
                flex-direction: column;
                padding: 0 ${spacing}px;
                gap: ${spacing}px;
                height: 100%;
                background: ${palette.neutral[700]};

                & > svg {
                    width: 32px;
                    height: 32px;
                }
                & h1 {
                    ${typography.textMd}
                    font-weight: 600;
                    line-height: normal;
                }
                & p {
                    line-height: normal;
                    ${typography.textXs}
                }

                & button {
                    ${typography.textXs}
                    ${flexUtils.centered}
                    display: flex;
                    gap: ${spacing / 2}px;
                    max-height: 24px;
                    width: fit-content;
                    margin-top: ${spacing}px;
                    padding: ${spacing}px ${spacing * 2}px;

                    & svg {
                        width: 12px;
                        height: 12px;
                    }
                }
            }
        `}
    `}
`

export const StyledVariant = {
    [UPDATE_VARIANT.MURAL]: StyledMuralSection,
    [UPDATE_VARIANT.PROFILE_MURAL]: StyledMuralSection,
    [UPDATE_VARIANT.CHAT]: StyledChatSection,
    [UPDATE_VARIANT.STORY]: StyledMuralSection
}

export const StyledRestrictionLayerWrapper = styled.div<{
    styledVariant: FlattenInterpolation<ThemeProps<DefaultTheme>>
}>`
    ${({styledVariant}) => css`
        ${styledVariant}
    `}
`

export const StyledRestrictionContent = styled.div``
